import { addDays, isSameDay as isSameDay_ } from "date-fns";

import type { RelativeTimeOptions } from "../relative-time-options";
import type { Time } from "../time";

export function isTomorrow(time: Time, { now }: RelativeTimeOptions): boolean {
	return isSameDay_(time, addDays(now, 1));
}
